import React from 'react';
import { Table } from 'rsuite';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const { HeaderCell } = Table;

const CustomHeader = styled(HeaderCell)`
  .rs-table-cell {
    color: #575757;
    border-right: 1px solid #ccc;
  }
  .rs-table-cell-header-sort-wrapper {
    position: absolute;
    left: 0;
  }
`;

const HeaderLabel = styled.span`
  font-weight: bold;
  margin-left: 10px;
`;

const CustomHeaderCell = ({ background, children, ...props }) => (
  <CustomHeader
    {...props}
    style={background ? { backgroundColor: background } : {}}
  >
    <HeaderLabel>{children}</HeaderLabel>
  </CustomHeader>
);

CustomHeaderCell.propTypes = {
  children: PropTypes.node,
  background: PropTypes.string
};

CustomHeaderCell.defaultProps = {
  children: null,
  background: ''
};

export default CustomHeaderCell;
